import React from 'react';
import './index.css';
import whymeImage from './imgs/home-whyme.svg';
import customizationImage from './imgs/home-customization.svg';
import integrationImage from './imgs/home-integrations.svg';

const yearsInEpicor = new Date().getFullYear() - 2013;

const services = [
  {
    href: '/why-me',
    image: whymeImage,
    alt: 'Epicor expertise across Kinetic, BPMs, BAQs, SSRS, Functions and Dashboards',
    title: 'Experience across the whole Epicor stack',
    body: 'Years on a Platinum Partner team and on my own mean most problems are ones I have solved before. You work directly with me, from the first call to go-live.',
    points: ['Kinetic and classic', 'BPMs and Functions', 'BAQs, SSRS and dashboards'],
    link: 'Why work with me',
  },
  {
    href: '/customizations',
    image: customizationImage,
    alt: 'A Kinetic form being customized and linked to a BPM workflow',
    title: 'Customizations and support that keep Epicor moving',
    body: 'Form changes, new fields, BPMs, reports and Bartender labels, plus the upgrades, performance tuning and emergency fixes that keep the system healthy.',
    points: ['Kinetic form customization', 'Upgrades and performance tuning', 'Emergency fixes'],
    link: 'See customizations and support',
  },
  {
    href: '/integrations',
    image: integrationImage,
    alt: 'Epicor ERP connected to CRM, e-commerce, EDI, Power BI, REST APIs and SQL',
    title: 'Integrations that go through Epicor, not around it',
    body: 'Connect Epicor to your CRM, store, EDI partners, Power BI or anything with an API. Data goes in through business logic, so your records stay intact.',
    points: ['REST and Epicor Functions', 'EDI, e-commerce and CRM', 'Bartender and Power BI'],
    link: 'See integrations',
  },
];

function Services() {
  return (
    <div className="home">
      <section className="home-hero">
        <div className="home-hero-inner">
          <h1 className="home-hero-title">Epicor that fits the way your business runs.</h1>
          <p className="home-hero-lede">
            Independent Epicor ERP consulting from Tampa Bay. Customizations, reports, integrations and
            support, done by someone who has worked inside more than 50 Epicor shops.
          </p>
          <div className="home-hero-actions">
            <a href="/contact" className="btn btn-primary">Book a call</a>
            <a href="/pricing" className="btn btn-ghost">See pricing</a>
          </div>
          <ul className="home-hero-proof">
            <li><strong>{yearsInEpicor} years</strong> in Epicor</li>
            <li><strong>50+</strong> clients</li>
            <li>Former <strong>Platinum Partner</strong> team</li>
          </ul>
        </div>
      </section>

      <section className="home-services" aria-label="Services">
        {services.map((s) => (
          <article className="service-row" key={s.href}>
            <a href={s.href} className="service-row-art" tabIndex={-1} aria-hidden="true">
              <img src={s.image} alt="" />
            </a>
            <div className="service-row-text">
              <h2 className="service-row-title">
                <a href={s.href}>{s.title}</a>
              </h2>
              <p>{s.body}</p>
              <ul className="service-row-points">
                {s.points.map((p) => <li key={p}>{p}</li>)}
              </ul>
              <a href={s.href} className="text-link">{s.link}</a>
            </div>
          </article>
        ))}
      </section>

      <section className="home-pricing">
        <div className="home-pricing-inner">
          <div>
            <h2 className="home-pricing-title">Plans start at $800 a month.</h2>
            <p>
              Monthly plans include hours and a guaranteed response time. For one-off work,
              ad hoc help is $200 an hour with no retainer.
            </p>
          </div>
          <a href="/pricing" className="btn btn-primary">Compare plans</a>
        </div>
      </section>
    </div>
  );
}

export default Services;
